import { Loader2 } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/Card';

export default function LoadingCard() {
  return (
    <Card className="mx-auto w-full max-w-2xl">
      <CardContent className="flex items-center justify-center py-10">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2">Loading user data...</span>
      </CardContent>
    </Card>
  );
}
